module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="info-window">\n	<div class="thumbnail">\n	';
 if (isMembersOnly) {  
__p+='\n		<span class="badge mo-icon pull-left">'+
((__t=( t('private_listing') ))==null?'':__t)+
'</span>\n	';
 } 
__p+='\n	';
 if (coverphoto) { 
__p+='\n		<picture>\n			<source type="image/webp" srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=314&h=196&f=webp">\n			<img src="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=314&h=196&f=jpg">\n		</picture>\n	';
 } else { 
__p+='\n		<div class="cntr-photo-placeholder">\n			<div class="photo-placeholder text-center">\n				<i class="fa fa-2x fa-lock"></i>\n				<p>Contact for more <br />information</p>\n			</div>\n		</div>\n	';
 } 
__p+='\n	</div>\n\n	<h2 class="title">\n		';
 if (isMembersOnly) { 
__p+='\n			'+
((__t=( title ))==null?'':__t)+
'\n		';
 } else if (structure.structure_type === 'house' && structure.unit) { 
__p+='\n			<a href="'+
((__t=( unitDetailsUrl(structure, structure.unit, section, key) ))==null?'':__t)+
'">'+
((__t=( title ))==null?'':__t)+
'</a>\n		';
 } else { 
__p+='\n			<a href="'+
((__t=( buildingUrl(structure, section) ))==null?'':__t)+
'">'+
((__t=( title ))==null?'':__t)+
'</a>\n		';
 } 
__p+='\n	</h2>\n\n	<p class="address">\n		'+
((__t=( address ))==null?'':__t)+
'\n	</p>\n\n	<table class="table table-sm table-hover">\n	';
 if (_.isArray(structure.units)) { 
__p+='\n		<thead>\n			<tr>\n				<th>'+
((__t=( t('title_unit') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_bedrooms') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_bathrooms') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_size') ))==null?'':__t)+
'</th>\n			';
 if (section === 'rent') { 
__p+='\n				<th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'buy') { 
__p+='\n				<th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'monthly') { 
__p+='\n				<th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n			';
 } 
__p+='\n				<th></th>\n			</tr>\n		</thead>\n		<tbody>\n		';
 for (const unit of structure.units) { 
__p+='\n			<tr>\n				<td>'+
((__t=( unit.room_no ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( bedroomNo(unit) ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( unit.bathroom_no ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( getSize(unit) ))==null?'':__t)+
' m&sup2;</td>\n				<td class="cost">\n					'+
((__t=( moneyFormat(getCost(unit)) ))==null?'':__t)+
'\n					';
 if (unit.starting_price) { 
__p+='~';
 } 
__p+='\n				</td>\n				<td>\n					<a href="'+
((__t=( unitDetailsUrl(structure, unit.id, section, key) ))==null?'':__t)+
'" class="btn btn-primary">'+
((__t=( t('view') ))==null?'':__t)+
'</a>\n				</td>\n			</tr>\n		';
 } 
__p+='\n		</tbody>\n	';
 } else if (structure.structure_type === 'house' && structure.unit) { 
__p+='\n		<thead>\n			<tr>\n				<th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_bedrooms') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_bathrooms') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_size') ))==null?'':__t)+
'</th>\n			';
 if (section === 'rent') { 
__p+='\n				<th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'buy') { 
__p+='\n				<th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'monthly') { 
__p+='\n				<th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n			';
 } 
__p+='\n				<th></th>\n			</tr>\n		</thead>\n		<tbody>\n			<tr>\n				<td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( bedroomNo(structure) ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( structure.bathroom_no ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( getSize(structure) ))==null?'':__t)+
' m&sup2;</td>\n				<td class="cost">\n					'+
((__t=( moneyFormat(getCost(structure)) ))==null?'':__t)+
'\n					';
 if (structure.starting_price) { 
__p+='~';
 } 
__p+='\n				</td>\n				<td>\n					<a href="'+
((__t=( unitDetailsUrl(structure, structure.unit, section, key) ))==null?'':__t)+
'" class="btn btn-primary">'+
((__t=( t('view') ))==null?'':__t)+
'</a>\n				</td>\n			</tr>\n		</tbody>\n	';
 } else if (structure.structure_type === 'land') { 
__p+='\n		<thead>\n			<tr>\n				<th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_land_size') ))==null?'':__t)+
'</th>\n			';
 if (section === 'rent') { 
__p+='\n				<th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'buy') { 
__p+='\n				<th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'monthly') { 
__p+='\n				<th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n			';
 } 
__p+='\n				<th></th>\n			</tr>\n		</thead>\n		<tbody>\n			<tr>\n				<td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( getSize(structure) ))==null?'':__t)+
' m&sup2;</td>\n				<td class="cost">\n					'+
((__t=( moneyFormat(getCost(structure)) ))==null?'':__t)+
'\n					';
 if (structure.starting_price) { 
__p+='~';
 } 
__p+='\n				</td>\n				<td>\n					<a href="'+
((__t=( buildingUrl(structure, section) ))==null?'':__t)+
'" class="btn btn-primary">'+
((__t=( t('view') ))==null?'':__t)+
'</a>\n				</td>\n			</tr>\n		</tbody>\n	';
 } else { 
__p+='\n		<thead>\n			<tr>\n				<th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n				<th>'+
((__t=( t('title_building_size') ))==null?'':__t)+
'</th>\n			';
 if (section === 'rent') { 
__p+='\n				<th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'buy') { 
__p+='\n				<th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n			';
 } else if (section === 'monthly') { 
__p+='\n				<th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n			';
 } 
__p+='\n				<th></th>\n			</tr>\n		</thead>\n		<tbody>\n			<tr>\n				<td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n				<td>'+
((__t=( getSize(structure) ))==null?'':__t)+
' m&sup2;</td>\n				<td class="cost">\n					'+
((__t=( moneyFormat(getCost(structure)) ))==null?'':__t)+
'\n					';
 if (structure.starting_price) { 
__p+='~';
 } 
__p+='\n				</td>\n				<td>\n					<a href="'+
((__t=( buildingUrl(structure, section) ))==null?'':__t)+
'" class="btn btn-primary">'+
((__t=( t('view') ))==null?'':__t)+
'</a>\n				</td>\n			</tr>\n		</tbody>\n	';
 } 
__p+='\n	</table>\n</div>';
}
return __p;
};
